// extracted by mini-css-extract-plugin
module.exports = {"Main":"Dashboard_Main__1VscD","Left":"Dashboard_Left__2XhXF"};